'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UISection from 'UIComponents/section/UISection';
const DefaultHeading = styled.span.attrs({
  className: 'is--heading-7'
}).withConfig({
  displayName: "ReviewSection__DefaultHeading",
  componentId: "sc-4w00dr-0"
})(["margin-bottom:4px;"]);

const ReviewSection = ({
  HeadingComponent,
  title,
  children
}) => {
  return /*#__PURE__*/_jsxs(UISection, {
    children: [title && /*#__PURE__*/_jsx(HeadingComponent, {
      children: title
    }), children]
  });
};

ReviewSection.propTypes = {
  HeadingComponent: PropTypes.elementType,
  title: PropTypes.node,
  children: PropTypes.node
};
ReviewSection.defaultProps = {
  HeadingComponent: DefaultHeading
};
export default ReviewSection;